<style lang="scss" scoped>
.detail-target {
  padding-bottom: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // 左侧
  .left {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }

  // 右侧
  .right {
    display: flex;
    align-items: center;
  }
}

.page {
  display: flex;
  justify-content: end;
  padding-top: 10px;
}
</style>

<template>
  <div ref="container" style="height: 100%;width: 100%;">
    <!-- 表单 -->
    <div class="form" ref="form">
      <el-form :model="searchForm" :inline="true" size="mini">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input format="yyyy-MM-dd" type="daterange" :start.sync="searchForm.startTime" :end.sync="searchForm.endTime"> </yi_time_input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData" plain>{{ $t('sousuo') }} </el-button>
          <el-button type="default" @click="resetSearch" plain style="margin-left: 10px;">
            {{ $t('chongzhi') }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 明细 -->
    <div class="detail-target" ref="title">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t('fenximingxi') }}</span>
      </div>
      <div class="right">
        <!-- <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportExcel"> </el-button> -->
      </div>
    </div>
    <div class="table" ref="table">
      <el-table :data="tableList" border size="mini" :row-style="{ height: 42 + 'px' }" :cell-style="{ padding: 0 + 'px' }" v-loading="searchLoading" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }">
        <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" style="min-width: 250px;" :width="item.width">
          <template slot-scope="scope">
            <span style="color: #606266">{{ handleData(scope.row, item) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 分页 -->
    <div class="page" v-if="tableList.length > 0">
      <el-pagination background layout="total, sizes, prev, pager, next" :page-sizes="[10, 20, 50, 100]" :page-size.sync="pageSize" :current-page.sync="pageNum" @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="tableData.length"> </el-pagination>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import dayjs from 'dayjs';
// 获取当月1号
const now = new Date();
const oneOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
// 设置时间为凌晨0点0分0秒
oneOfMonth.setHours(0, 0, 0, 0);
// 获取当月最后一天
const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
// 设置时间为当天23点59分59秒 注意：毫秒数只能到999
endOfMonth.setHours(23, 59, 59, 999);
export default {
  name: 'web_customize_zhongshuo_report_produce_report_tab_production_report_analysis',
  data() {
    return {
      searchLoading: false,
      searchForm: {
        startTime: oneOfMonth.getTime(),
        endTime: endOfMonth.getTime()
      },
      pageNum: 1,
      pageSize: 10,
      tableList: [],
      tableData: [],
      tableColumn: [
        {
          label: 'riqi',
          prop: 'summaryTime',
          type: 'date',
          width: 120
        },
        {
          label: 'banci',
          prop: 'shiftName'
        },
        {
          label: 'shebeijitai',
          prop: 'machineNumber'
        },
        {
          label: 'gongxu',
          prop: 'processName'
        },
        {
          label: 'shengchandingdanhao',
          prop: 'orderNumber',
          width: 120
        },
        {
          label: 'mujubianma',
          prop: 'mouldCode'
        },
        {
          label: 'chanpinbianhao',
          prop: 'materialNumber',
          width: 120
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName'
        },
        {
          label: 'caozuoren',
          prop: 'operator'
        },
        {
          label: 'biaozhunzhouqi(s)',
          prop: 'standardCycle',
          type: 'decimal',
          width: 120
        },
        {
          label: 'shijizhouqi(s)',
          prop: 'actualCycle',
          type: 'decimal',
          width: 120
        },
        {
          label: 'moxueshu',
          prop: 'cavity'
        },
        {
          label: 'wangongshuliang',
          prop: 'completedQuantity'
        },
        {
          label: 'hegeshuliang',
          prop: 'qualifiedQuantity'
        },
        {
          label: 'buhegeshuliang',
          prop: 'unqualifiedQuantity',
          width: 120
        },
        {
          label: 'jiagongcaozuoshijian(h)',
          prop: 'processingOperationTime',
          type: 'decimal',
          width: 120
        },
        {
          label: 'rengongshijian(h)',
          prop: 'laborTime',
          type: 'decimal',
          width: 120
        },
        {
          label: 'shebeijilushuliang',
          prop: 'machineQuantity',
          width: 120
        },
        {
          label: 'chayishuliang',
          prop: 'diffQuantity'
        },
        {
          label: 'shebeikaishishijian',
          prop: 'equipmentStartTime',
          type: 'datetime',
          width: 150
        },
        {
          label: 'shebeijieshushijian',
          prop: 'equipmentEndTime',
          type: 'datetime',
          width: 150
        },
        {
          label: 'jiagongbiaozhunchanneng',
          prop: 'standardCapacity',
          width: 120
        },
        {
          label: 'jiagongshengchanxiaolv',
          prop: 'processingProductionEfficiency',
          type: 'percent',
          width: 120
        },
        {
          label: 'shengchanhegelv',
          prop: 'productionQualificationRate',
          type: 'percent',
          width: 120
        },
        {
          label: 'banzu',
          prop: 'team'
        },
        {
          label: 'lingban',
          prop: 'gaffer'
        }
      ]
    };
  },
  created() {
    this.getData();
  },
  methods: {
    // 页面显示条数改变时调用
    handleSizeChange(size) {
      this.pageNum = 1;
      this.page();
    },
    // 当前页改变时调用
    handleCurrentChange(num) {
      this.page();
    },
    // 分页函数
    page() {
      const startIndex = (this.pageNum - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.tableList = this.tableData.slice(startIndex, endIndex);
    },
    // 获取数据
    getData() {
      this.searchLoading = true;
      this.http
        .get('/custom/zhongshuo/wo/report/record/statistical/production/report/analysis', {
          params: this.searchForm
        })
        .then(res => {
          this.tableData = res.data || [];
          this.page();
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.searchLoading = false;
        });
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        startTime: oneOfMonth.getTime(),
        endTime: endOfMonth.getTime()
      };
      this.getData();
    },

    // 处理数据
    handleData(row, item) {
      const type = item.type;
      const data = row[item.prop];
      if (data != undefined) {
        switch (type) {
          case 'date': {
            return dayjs(data).format('YYYY-MM-DD');
          }
          case 'datetime': {
            return dayjs(data).format('YYYY-MM-DD HH:mm:ss');
          }
          case 'decimal': {
            return data.toFixed(2);
          }
          case 'percent': {
            return (data * 100).toFixed(2) + '%';
          }
          default: {
            return data;
          }
        }
      } else {
        return data;
      }
    },

    // 从嵌套对象中取值
    getValueByPath(obj, path) {
      const parts = path.split('.');
      let current = obj;
      for (let i = 0; i < parts.length; i++) {
        if (current[parts[i]] !== undefined) {
          current = current[parts[i]];
        } else {
          // 如果路径中的某一部分不存在，返回undefined
          return undefined;
        }
      }
      return current;
    }
  }
};
</script>
